export default function(store, action) {
  return {
    ...store,
    loading: action.toggle,
  }
}
